/* eslint-disable no-param-reassign */
import filter from 'lodash/filter';
import set from 'lodash/set';

import createSlice, { PayloadAction } from '@lumapps/redux/createSlice';

import { SpaceAccessRequestStatus, SpaceData, SpacePinnedResource } from '../types';

export const domain = 'space';

export interface SpaceState {
    isMembershipRequestLoading: boolean;
    isNavigationAdminDialogOpen: boolean;
    data: SpaceData | null;
    id: string | null;
}

export const initialState: SpaceState = {
    isMembershipRequestLoading: false,
    isNavigationAdminDialogOpen: false,
    data: null,
    id: null,
};

export const { actions, reducer } = createSlice({
    domain,
    initialState,
    reducers: {
        reset: () => initialState,
        success: (state: SpaceState, action: PayloadAction<{ data: SpaceData; id: string }>) => {
            state.data = action.payload.data;
            state.id = action.payload.id;
        },
        requestAccessRequest: (state: SpaceState) => {
            state.isMembershipRequestLoading = true;
        },
        requestAccessSuccess: (state: SpaceState) => {
            state.isMembershipRequestLoading = false;
            set(state, 'data.myMembership.requestDetails', { status: SpaceAccessRequestStatus.pending });
        },
        requestAccessFailure: (state: SpaceState) => {
            state.isMembershipRequestLoading = false;
        },
        pinResource: (state: SpaceState, action: PayloadAction<SpacePinnedResource>) => {
            // we should add the post to pinned resources only when in the context of a space
            if (state.data) {
                const newPinnedResources = [...(state.data.pinnedResources ?? []), action.payload];
                set(state, 'data.pinnedResources', newPinnedResources);
            }
        },
        unpinResource: (state: SpaceState, action: PayloadAction<SpacePinnedResource>) => {
            // we should delete the post from the pinned resources only when they exist, in the context of a space
            if (state.data?.pinnedResources) {
                const newPinnedResources = filter(
                    state.data.pinnedResources,
                    (resource) => resource.id !== action.payload.id,
                );
                set(state, 'data.pinnedResources', newPinnedResources);
            }
        },
        openNavigationAdminDialog: (state: SpaceState) => {
            state.isNavigationAdminDialogOpen = true;
        },
        closeNavigationAdminDialog: (state: SpaceState) => {
            state.isNavigationAdminDialogOpen = false;
        },
    },
});
